import {Component, EventEmitter, isDevMode, Output} from '@angular/core';
import { ALL_ITEMS } from '@shared/layout/services/menu-items';
import { BrandingComponent } from '../branding/branding.component';
import { NavComponent } from './nav/nav.component';
import { version } from '../../../../../../package.json';

@Component({
  selector: 'pd-menu',
  imports: [
    NavComponent,
    BrandingComponent
  ],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss'
})
export class MenuComponent {
  @Output() menuClosed = new EventEmitter<void>();

  menuItems = ALL_ITEMS;

  protected readonly isDevMode = isDevMode;
  protected readonly version = version;
}
